import styled, { css } from 'styled-components';

const inputStyles = css`
  width: auto;
  min-width: 1ch;
  max-width: 100%;
  border: none;
  outline: none;
  background: transparent;
  box-shadow: none;
  padding: 0;
  color: inherit;
  font: inherit;
  line-height: inherit;
  resize: none;
  field-sizing: content;
`;

export const StyledEditableText = styled.div`
  display: inline-flex;
  align-items: ${props => (props.$multiline ? 'flex-start' : 'center')};
  gap: 6px;
  max-width: 360px;
  color: rgba(0, 0, 0, 0.85);
`;

export const StyledValue = styled.span`
  overflow-wrap: break-word;
  cursor: text;
  ${props => props.$isPlaceholder && css`
    opacity: 0.7;
  `}
`;

export const StyledEditHint = styled.span`
  opacity: 0;
  transition: opacity 0.15s ease;
  color: rgba(0, 0, 0, 0.35);
  line-height: 1;
  pointer-events: none;

  ${StyledEditableText}:hover &,
  ${StyledEditableText}:focus-within & {
    opacity: 1;
  }
`;

export const StyledInput = styled.input`
  ${inputStyles}
`;

export const StyledTextarea = styled.textarea`
  ${inputStyles}
`;
